import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

import 'react-photo-album/masonry.css';

import './index.css';
import 'swiper/css';
import 'swiper/css/thumbs';
import 'swiper/css/pagination';

/* -------------------- Service Worker Registration -------------------- */
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/service-worker.js')
            .catch((error: unknown) => {
                console.error('ServiceWorker registration failed:', error);
            });
    });
}

/* -------------------- Application Bootstrap -------------------- */
const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
